{
	"backToManageDeclarations": "Назад към Управление на декларации"
}
